(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7482],{

/***/ 58052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "loadParams": function() { return /* binding */ loadParams; }
/* harmony export */ });
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17674);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var shared_components_pages_proyectos_RealestateList__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30005);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1283);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var shared_models_const_businessTypes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80074);
/* harmony import */ var shared_models_const_property_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86465);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var shared_models_functions_title_dinamic_properties_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16371);
/* harmony import */ var shared_models_functions_description_dinamic_properties_helper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81796);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(57626);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70917);













var __N_SSP = true;
var loadParams = function loadParams(params) {
  var _params = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(params, 4),
      BusinessType = _params[0],
      typeProperty = _params[1],
      city = _params[2],
      sector = _params[3];

  var filters = {};

  if (BusinessType) {
    filters["businessTypes"] = BusinessType == shared_models_const_businessTypes__WEBPACK_IMPORTED_MODULE_4__/* .CBusinessTypes[0].label.toLowerCase */ .b[0].label.toLowerCase() ? shared_models_const_businessTypes__WEBPACK_IMPORTED_MODULE_4__/* .CBusinessTypes[0].value */ .b[0].value : shared_models_const_businessTypes__WEBPACK_IMPORTED_MODULE_4__/* .CBusinessTypes[1].value */ .b[1].value;
  }

  if (sector) {
    filters["sectorName"] = sector;
  }

  if (typeProperty) {
    var _CPropertyTypes$find;

    filters["typeProperty"] = [(_CPropertyTypes$find = shared_models_const_property_types__WEBPACK_IMPORTED_MODULE_5__/* .CPropertyTypes.find */ .Rl.find(function (x) {
      return x.name.toLowerCase() == typeProperty.replaceAll("-", " ");
    })) === null || _CPropertyTypes$find === void 0 ? void 0 : _CPropertyTypes$find.slug];
  }

  if (city) {
    filters["cityName"] = city;
    filters["locations"] = [{
      id: null,
      description: city.replaceAll("-", " ").toUpperCase()
    }];
  }

  return filters;
};

var PropiedadDynamic = function PropiedadDynamic(props) {
  var _titleDynamicProperti, _titleDynamicProperti2;

  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_10__.useTranslations)("title-pages");
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var filters = {
    refRequest: "propiedades-list-query",
    detailPath: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_3__/* .CPagesPath.es.property_detail */ .K.es.property_detail,
    filters: loadParams(props.params),
    seoDynamic: true
  };
  var metaData = {
    title: ((_titleDynamicProperti = (0,shared_models_functions_title_dinamic_properties_helper__WEBPACK_IMPORTED_MODULE_7__/* .titleDynamicProperties */ .n)(router)) === null || _titleDynamicProperti === void 0 ? void 0 : _titleDynamicProperti.toUpperCase()) + "RE/MAX República Dominicana",
    description: (0,shared_models_functions_description_dinamic_properties_helper__WEBPACK_IMPORTED_MODULE_8__/* .descriptionDynamicProperties */ .q)(router),
    url: "https://remaxrd.com" + router.asPath,
    realstateType: props.params[1],
    picture: "https://remaxrd.com" + "/icons/image-optimize/living_meta.jpg"
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("title", null, filters.seoDynamic ? (_titleDynamicProperti2 = (0,shared_models_functions_title_dinamic_properties_helper__WEBPACK_IMPORTED_MODULE_7__/* .titleDynamicProperties */ .n)(router)) === null || _titleDynamicProperti2 === void 0 ? void 0 : _titleDynamicProperti2.toUpperCase() : titleT("properties")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: "Propiedad exclusivos, proyecto exclusivo en construcci\xF3n, proyecto exclusivo construido, Propiedad exclusivos remax rd, casas en venta, villas en venta, townhouse en venta, apartamentos en venta, oficinas en venta, almac\xE9n en venta, casas en alquiler, villas en alquiler, townhouse en alquiler, apartamento en alquiler, oficinas en alquiler, almac\xE9n en alquiler, Propiedad exclusivos de remax rep\xFAblica dominicana"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("title", null, metaData.title), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("meta", {
    name: "description",
    content: metaData.description
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("meta", {
    property: "og:url",
    content: metaData.url
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("meta", {
    property: "og:type",
    content: metaData.realstateType
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("meta", {
    property: "og:title",
    content: metaData.title
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("meta", {
    property: "og:description",
    content: metaData.description
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("meta", {
    property: "og:image",
    content: metaData.picture
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)("".concat("https://remaxrd.com").concat(props.url)),
    key: "canonical"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(shared_components_pages_proyectos_RealestateList__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    defaultFilters: filters
  }));
};

/* harmony default export */ __webpack_exports__["default"] = (PropiedadDynamic);

/***/ }),

/***/ 81796:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ descriptionDynamicProperties; }
/* harmony export */ });
/* unused harmony export seoDescriptionHandler */
/* harmony import */ var _usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17674);
/* harmony import */ var _const_property_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86465);
/* harmony import */ var _const_seo_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4674);



var descriptionDynamicProperties = function descriptionDynamicProperties(router) {
  var params = router.asPath.split('?')[0].split("/");
  var BaseMessage = "Encuentra los mejores inmuebles";

  if (params.length == 6) {
    return "".concat(BaseMessage, " de ").concat(params[3], "s en ").concat(params[2], " en ").concat(params[5].replaceAll('-', " "), ", ").concat(params[4].replaceAll('-', " "), " ");
  } else if (router.pathname === _const_seo_const__WEBPACK_IMPORTED_MODULE_1__/* .seoPathname */ .G) {
    return BaseMessage + seoDescriptionHandler(params.join('/'));
  } else if (params.length == 5) {
    return "".concat(BaseMessage, " de ").concat(params[3], "s en ").concat(params[2], " en ").concat(params[4].replaceAll('-', " "));
  } else if (params.length == 4) {
    return "".concat(BaseMessage, " de ").concat(params[3], "s en ").concat(params[2], " ");
  } else if (params.length == 3) {
    return "".concat(BaseMessage, " ").concat(params[2]);
  }
};
var seoDescriptionHandler = function seoDescriptionHandler(path) {
  var _CPropertyTypes$find;

  var _path$substring$split = path.substring(1).split("/"),
      _path$substring$split2 = (0,_usr_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_path$substring$split, 4),
      _ = _path$substring$split2[0],
      propertyType = _path$substring$split2[1],
      city = _path$substring$split2[2],
      sector = _path$substring$split2[3];

  var propertyTypePlural = (_CPropertyTypes$find = _const_property_types__WEBPACK_IMPORTED_MODULE_0__/* .CPropertyTypes.find */ .Rl.find(function (x) {
    return x.name.toLowerCase() == propertyType.toLocaleLowerCase().replace(/-/g, " ");
  })) === null || _CPropertyTypes$find === void 0 ? void 0 : _CPropertyTypes$find.plural;
  var result = " de " + propertyTypePlural;

  if (city) {
    result += " en " + city.replace(/-/g, " ");
    if (sector) result += ", " + sector.replace(/-/g, " ");
  } else {
    result += " en República Dominicana";
  }

  return result;
}; // de Apartamentos de Venta en Piantini, Santo Domingo

/***/ }),

/***/ 93713:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/propiedades/[...params]",
      function () {
        return __webpack_require__(58052);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3828,8584,8360,7899,2203,8654,9470,4003,1691,5,9774,2888,179], function() { return __webpack_exec__(93713); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);